import { gql } from '@apollo/client'

export const GET_ALL_SCHEDULE_GROUPS = gql`
  query GetAllScheduleGroupsEmployees(
    $searchQuery: String
    $limit: Int
    $offset: Int
  ) {
    getAllScheduleGroupsEmployees(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
    ) {
      count
      rows {
        id
        name
        description
        GroupsToGroupDetails {
          id
          schedule_group_id
          start_day_of_week
          end_day_of_week
          start_time
          end_time
          tolerance_minutes
          is_active
          start_day_of_week_spanish
          end_day_of_week_spanish
        }
      }
    }
  }
`

export const GET_SCHEDULE_GROUP_BY_ID = gql`
  query GetScheduleGroupById($getScheduleGroupByIdId: Int!) {
    getScheduleGroupById(id: $getScheduleGroupByIdId) {
      id
      name
      description
      is_active
      GroupsToGroupDetails {
        id
        schedule_group_id
        start_day_of_week
        end_day_of_week
        start_time
        end_time
        tolerance_minutes
        is_active
        start_day_of_week_spanish
        end_day_of_week_spanish
      }
    }
  }
`

export const CREATE_SCHEDULE_GROUP = gql`
  mutation CreateScheduleGroupEmployees($input: employeesScheduleGroupsInput!) {
    createScheduleGroupEmployees(input: $input)
  }
`

export const UPDATE_SCHEDULE_GROUP = gql`
  mutation UpdateScheduleGroupEmployees(
    $updateScheduleGroupEmployeesId: Int!
    $input: employeesScheduleGroupsInput!
  ) {
    updateScheduleGroupEmployees(
      id: $updateScheduleGroupEmployeesId
      input: $input
    )
  }
`

export const DELETE_SCHEDULE_GROUP = gql`
  mutation DeleteScheduleGroupEmployees($deleteScheduleGroupEmployeesId: Int!) {
    deleteScheduleGroupEmployees(id: $deleteScheduleGroupEmployeesId)
  }
`
